import styles from './PaymentCard.module.scss'
import React from 'react'
import * as PropTypes from 'prop-types'
import clsx from 'clsx'

const PaymentCard = ({
  className = '',
  children = null,
  icon = null,
  backgroundColor = null,
  color = null,
}) => {
  return (
    <div className={clsx(styles['payment-card'], className)}>
      <div className={styles['payment-card__in']}>
        <div
          className={styles['payment-card__preview-card']}
          style={{
            backgroundColor,
            color,
          }}
        >
          <div className={styles['payment-card__preview-card-logo']}>
            {icon}
          </div>
          <div className={styles['payment-card__preview-card-backdrop']}>
            <div
              className={styles['payment-card__preview-card-balloons']}
              style={{
                boxShadow: `${backgroundColor} 0 0 0 4px`,
              }}
            />
          </div>
          <div className={styles['payment-card__preview-card-content']}>
            {children}
          </div>
          <div
            className={styles['payment-card__preview-card-balloons']}
            style={{ boxShadow: `${backgroundColor} 0 0 0 4px` }}
          />
          <div className={styles['payment-card__preview-card-shadow']} />
        </div>
      </div>
    </div>
  )
}

PaymentCard.propTypes = {
  type: PropTypes.oneOf(['default', 'white']),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.oneOf([null])]),
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.oneOf([null])]),
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
}

export default PaymentCard
